import { render, staticRenderFns } from "./downloadDeclarationDialog.vue?vue&type=template&id=110b1548&scoped=true"
import script from "./downloadDeclarationDialog.vue?vue&type=script&lang=js"
export * from "./downloadDeclarationDialog.vue?vue&type=script&lang=js"
import style0 from "./downloadDeclarationDialog.vue?vue&type=style&index=0&id=110b1548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110b1548",
  null
  
)

export default component.exports